export default __webpack_public_path__ + "static/media/placeholder-landscape.c21ca8fe.svg";